import { Injectable } from "@angular/core"
import { Http, Headers, Response } from "@angular/http"
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { JwtHelper } from 'angular2-jwt';

import { HttpHelperService } from './helpers/http-helper.service';

import * as jwt from 'jsonwebtoken';



let jwtHelper: JwtHelper = new JwtHelper();

function asObservable(subject: Subject<any>) {
    return new Observable((fn: any) => subject.subscribe(fn));
}

@Injectable()

export class UserService {
    private currentUserSource: BehaviorSubject<any> = new BehaviorSubject([]);

    get currentUser() {
        return asObservable(this.currentUserSource);
    }

    constructor (
        private http: Http,
        private httpHelperService: HttpHelperService
    ) { }


    getToken() {
		return UserService.token;
	}
	static get token(): string {
		return localStorage.getItem("token");
	}
	static set token(token: string) {
		if (token) {
			localStorage.setItem("token", token);
        } else {
			localStorage.removeItem("token");
        }
    }

	registerToken() {
		const today = new Date();
		const exp = new Date(today);
		const expire = 1;
		exp.setDate(today.getDate() + expire);
		// return jwt.sign({
		// 	iss: process.env.TOKEN_ISSUER || 'localhost:1400',
		// 	exp: parseInt('' + exp.getTime() / 1000),
		// }, process.env.TOKEN_SECRET || 'SECRET');
		return jwt.sign({foo: "bar" }, 'SECRET');
	}

    invalidateToken() {
		UserService.token = "";
	}

    isLoggedin() {
		let token = UserService.token;
		if (!!token) {
            try {
                let payload = jwtHelper.decodeToken(token);

                return !jwtHelper.isTokenExpired(token);
            } catch (error) {
                return false;
            }
		}
		return false;
    }

    isAdminUser() {
        let token = UserService.token;
		if (!!token) {
            try {
                let payload = jwtHelper.decodeToken(token);
                return !jwtHelper.isTokenExpired(token) && payload.isAdmin === true;
            } catch (error) {
                return false;
            }
		}
		return false;
    }

    login(user) {
		return this.http.post('api/auth/login', JSON.stringify(user), {headers: this.httpHelperService.headers()})
		.map((res) => {
			let token = res.json().token;
			UserService.token = token;
			return res.json();
		})
		.catch(this.handleErrors);
    }

    logout() {
        this.invalidateToken();
        localStorage.removeItem('promotion-closed')
        window.location.reload();
    }

    getCurrentUser() {
        const token = UserService.token
        if (this.isLoggedin()) {
            return this.http.get('/api/userinfo', { headers: this.httpHelperService.headers(true, UserService.token) })
            .subscribe((res: any) => {
                this.currentUserSource.next(res.json());
                return res.json();
            })
        } else {
            return Promise.resolve('false')
        }
    }

    forgotPassword(user) {
        return new Promise((resolve, reject) => {
            const body = user;
            this.http.post('/api/forgotpassword', body, {headers: this.httpHelperService.headers(false)})
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            })
        })
    }

    resetPassword(user) {
        return new Promise((resolve, reject) => {
            const body = user;
            this.http.post('/api/resetpassword', body, {headers: this.httpHelperService.headers(false)})
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            })
        })
    }

    updateUserDetails(userData) {
        return new Promise((resolve, reject) => {
            const body = userData;
			this.http.post('/api/updatedetails', body, { headers: this.httpHelperService.headers(true, UserService.token) })
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    updateUserEmail(userData) {
        return new Promise((resolve, reject) => {
            const body = userData;
			this.http.post('/api/updateemail', body, { headers: this.httpHelperService.headers(true, UserService.token) })
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    updateUserPassword(userData) {
        return new Promise((resolve, reject) => {
            const body = userData;
			this.http.post('/api/updatepassword', body, { headers: this.httpHelperService.headers(true, UserService.token) })
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    registerUser(userData) {
		// TODO: jwt token
		// console.log('registerToken', this.registerToken());

        return new Promise((resolve, reject) => {
            const body = userData;
			this.http.post('/api/register', body, { headers: this.httpHelperService.headers(false) })
			// this.http.post('/api/register', body, { headers: this.httpHelperService.headers(true, this.registerToken() ) })
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    verifyUser(data) {
        return new Promise((resolve, reject) => {
            const body = data;
            this.http.post('/api/verifyaccount', body, { headers: this.httpHelperService.headers(false) })
            .subscribe((res: any) => {
                var result = res.json();
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    verifyUserForm(data) {
        return new Promise((resolve, reject) => {
            const body = data;
            this.http.post('/api/verifyaccountform', body, { headers: this.httpHelperService.headers(false) })
            .subscribe((res: any) => {
                var result = res.json();
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    addOrRemoveFavourite(data) {
        return new Promise((resolve, reject) => {
            const body = data;
			this.http.post('/api/addorremovefavourite', body, { headers: this.httpHelperService.headers(true, UserService.token) })
            .subscribe((res: any) => {
                var result = res.json();
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    checkEmailAvailable(data: any) {
        const body = data;
        return this.http.post('/api/check-email', body, { headers: this.httpHelperService.headers(false)})
        .map((res) => {
            return res.json();
        })
        .catch(this.handleErrors);
    }

    checkABN(data: any) {
        const body = data;
        return this.http.post('/api/check-abn', body, { headers: this.httpHelperService.headers(false)})
        .map((res) => {
            return res.json();
        })
        .catch(this.handleErrors);
    }

    checkToken(data: any) {
        const body = data;
        return this.http.post('/api/check-token', body, { headers: this.httpHelperService.headers(false)})
        .map((res) => {
            return res.json();
        })
        .catch(this.handleErrors);
    }

    exportCSV() {
        return new Promise((resolve, reject) => {
            const body = {}
            return this.http.post('/api/admin/exportcsv', body, {headers: this.httpHelperService.headers(true, UserService.token)})
                .subscribe((res: any) => {
                    const result = res.json()
                    resolve(result)
                }, (err: any) => {
                    reject(err)
                })
        })
    }

    searchUser(data: any) {
        return new Promise((resolve, reject) => {
            const body = data
            return this.http.post('/api/admin/searchuser', body, {headers: this.httpHelperService.headers(true, UserService.token)})
            .subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err.json())
            })
        })
    }

    deleteUser(user: any) {
        return new Promise((resolve, reject) => {
            const body = user
            return this.http.delete('/api/admin/user/' + body._id, {headers: this.httpHelperService.headers(true, UserService.token)})
                .subscribe((res: any) => {
                    var result = res.json()
                    if (result) {
                        resolve(result)
                    } else {
                        reject(result)
                    }
                }, (err: any) => {
                    reject(err.json())
                })
        })
    }

    handleErrors(error: Response) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts